/**
 * @desc 广告模块
 */
const analysis = r => require.ensure([], () => r(require('../views/dashboard/Analysis.vue')), 'analysis');

export default [
  //APP模块列表
  {
    name: 'analysis',
    path: '/analysis',
    component: analysis,
    meta: { title: '数据展示' },
  },
]